import { Component } from 'preact';

import WindRoseBuilder from '../../utils/wind-rose';
import handleLoadingAndError from '../handle-loading-and-error';
import sizeAware from '../size-aware';
import style from './style.scss';

/**
 * The WindRose component renders a windrose chart.
 *
 * props:
 * - data: the windrose data from the api.
 * - speedUnit: see SPEED_UNIT
 * - onUpdate: optional callback function called when the wind rose has rendered
 */
class WindRose extends Component {

	constructor(props) {
		super(props);
		this.windrose = null;
	}

	componentDidMount() {
		if (this.props.data) {
			this.update(this.props.data, this.props.speedUnit);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.data !== this.props.data || nextProps.speedUnit !== this.props.speedUnit) {
			this.update(nextProps.data, nextProps.speedUnit);
		} else if (nextProps.windowWidth !== this.props.windowWidth) {
			this.update(this.props.data, this.props.speedUnit);
		}
	}

	update(data, speedUnit) {
		// If there is data existing, keep the container size constant
		// before destroying and re-rendering so that the page doesn't jump.
		if (this.windrose !== null) {
			const size = this.windroseContainer.getBoundingClientRect();
			this.windroseContainer.style.width = size.width + 'px';
			this.windroseContainer.style.height = size.height + 'px';
		}

		const windrose = new WindRoseBuilder(data, speedUnit);
		this.windroseContainer.innerHTML = '';
		windrose.render(this.windroseContainer);

		if (this.props.onUpdate) {
			this.props.onUpdate();
		}

		if (this.windrose !== null) {
			this.windroseContainer.style.width = '';
			this.windroseContainer.style.height = '';
		}

		this.windrose = windrose;
	}

	render(props) {
		return (
			<div>
				<div class="hw_wind_rose" ref={el => { this.windroseContainer = el; }} />
				<p class={style.wind_rose_description}>
					The wind rose is a visual representation of wind direction and speed
					distribution over a certain period of time. Longer bars represent wind
					directions more prevalent during a period, whilst warmer colours show
					stronger wind speeds. The numbers on the rings which extend out from
					the center represent percentages. For instance, a bar which reaches to
					the ring marked 10 means that the wind blew from that direction 10% of
					the time during that period. Note that the bars may not sum to 100% as
					totally calm conditions are not included in the wind rose.
				</p>
			</div>
		);
	}

}

export default handleLoadingAndError(sizeAware(WindRose));



// WEBPACK FOOTER //
// ./components/windrose/index.js